import { useEffect, useRef, useState } from "react";
import { capitalizeFirstLetter } from "../../EditablePreview/EditablePreview";

const ModuleTextInput = ({ fieldLabel, value, fieldId, enabled = true, onChange, onClick, maxLength, editable = true, type = 'text', fakeDropDown = false, hiddenDropDown = false, hiddenDropDownOptions = [], dropDownValue = null, readonly = false, multiline = false, squareBottom = false }) => {
    const [currentValue, setCurrentValue] = useState(value);
    useEffect(() => {
        setCurrentValue(value ?? '-');
    }, [value]);

    const dropDownOptions = [];
    for (let i = 0; i < hiddenDropDownOptions.length; i++) {
        dropDownOptions.push(hiddenDropDownOptions[i]);
    }
    let foundValue = false;
    if (typeof dropDownValue === 'undefined' || dropDownValue === null || dropDownValue === '') {
        dropDownValue = value;
    }
    if (typeof dropDownValue !== 'undefined' && dropDownValue !== null) {
        for (const option of dropDownOptions) {
            if (option.value == dropDownValue || option.val == dropDownValue || option == dropDownValue) {
                foundValue = true;
                break;
            }
        }
    }
    if (!foundValue && typeof dropDownValue !== 'undefined' && dropDownValue !== null) {
        dropDownOptions.unshift({ label: typeof dropDownValue === 'string' ? capitalizeFirstLetter(dropDownValue) : dropDownValue, value: dropDownValue });
    }

    // console.log('Dropdown options:', dropDownOptions, 'with value:', dropDownValue);

    const extraStyle = {};
    if (squareBottom) {
        extraStyle.borderRadius = '3px 3px 0 0';
        // extraStyle.borderBottomWidth = '0';
    }

    return (
        <div className={`v2-module-input-holder${!enabled ? ' v2-module-disabled-field' : ''}${!editable && onClick ? ' v2-clickable' : ''}`} onClick={!editable ? onClick : null}>
            {!multiline &&
                <input
                    type={type}
                    className={`v2-module-input${!editable && onClick ? ' v2-no-mouse-events' : ''}${fieldLabel && fieldLabel !== '' ? ' v2-input-has-label' : ''}${(fakeDropDown || hiddenDropDown) ? ' v2-module-fake-dropdown' : ''}${readonly ? ' v2-module-readonly-input' : ''}`}
                    style={extraStyle}
                    value={currentValue ?? '-'}
                    maxLength={maxLength}
                    onChange={enabled && editable ? (e) => setCurrentValue(e.target.value) : null}
                    onKeyDown={enabled && editable ? (e) => {
                        if (e.key === 'Enter') {
                            onChange(fieldId, currentValue);
                        }
                        if (e.key === 'Escape') {
                            setCurrentValue(value ?? '-');
                        }
                    } : null}
                    onBlur={enabled && editable ? () => {
                        onChange(fieldId, currentValue);
                    } : null}
                    disabled={!enabled || !editable}
                />
            }
            {multiline &&
                <textarea
                    className={`v2-module-input v2-multiline-input${!editable && onClick ? ' v2-no-mouse-events' : ''}${fieldLabel && fieldLabel !== '' ? ' v2-input-has-label' : ''}${(fakeDropDown || hiddenDropDown) ? ' v2-module-fake-dropdown' : ''}${readonly ? ' v2-module-readonly-input' : ''}`}
                    style={extraStyle}
                    value={currentValue ?? '-'}
                    maxLength={maxLength}
                    onChange={enabled && editable ? (e) => setCurrentValue(e.target.value) : null}
                    onKeyDown={enabled && editable ? (e) => {
                        if (e.key === 'Escape') {
                            setCurrentValue(value ?? '-');
                        }
                    } : null}
                    onBlur={enabled && editable ? () => {
                        onChange(fieldId, currentValue);
                    } : null}
                    disabled={!enabled || !editable}
                    rows={3}
                />
            }
            {fieldLabel && fieldLabel !== '' && 
                <div className="v2-module-field-input-label">{fieldLabel}</div>
            }
            {fakeDropDown &&
                <div className="v2-module-fake-dropdown-icon" />
            }
            {hiddenDropDown && hiddenDropDownOptions.length > 0 &&
                <>
                    <div className="v2-module-fake-dropdown-icon" />
                    {enabled &&
                        <select
                            className={`v2-module-hidden-dropdown${!editable ? ' v2-wide-dropdown' : ''}`}
                            id="hidden-dropdown"
                            value={dropDownValue ?? currentValue}
                            onChange={(e) => {
                                // setCurrentValue(e.target.value);
                                onChange(fieldId, e.target.value);
                            }}
                        >
                            {dropDownOptions.map((option, index) => (
                                <option key={`o_${index}`} value={typeof option?.value !== "undefined" ? option.value : typeof option?.val !== "undefined" ? option?.val : option}>{option?.label ?? option}&nbsp;</option>
                            ))}
                        </select>
                    }
                </>
            }
        </div>
    );
}

export default ModuleTextInput;
